<template>
    <div class="modal-content">
        <div class="modal-header">
            <h5 class="modal-title" id="confirm-delete-modal-label">
                {{ $root.text('Bulk upload', null, true) }}
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">×</span>
            </button>
        </div>
        <div class="modal-body">
            {{ 
                $root.text(
                    'All required fields are complete. Would you like to upload all files now or add custom data '
                        + 'to each?',
                    null,
                    true
                )
            }}
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-primary mr-2" data-dismiss="modal" @click="$parent.onSubmit()">
                <i class="far fa-upload mr-1"></i>
                {{ $root.text('upload all now', null, true) }}
            </button>
            <button type="button" class="btn btn-primary" data-dismiss="modal" @click="$parent.selectFile('next', true)">
                <i class="far fa-edit mr-1"></i>
                {{ $root.text('add custom data', null, true) }}
            </button>
        </div>
    </div>
</template>

<script>
    export default {
        mounted () {
            //
        },
        methods: {
            //
        }
    }
</script>
